import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  Navigate,
  isRouteErrorResponse,
  useRouteError,
} from "react-router-dom";

import { ReactComponent as SmileSad } from "../../../../common/icons/smileSad.svg";
import { HomeMenu } from "../../../../features/home/HomeMenu";
import { HomeDrawer } from "../../../../features/home/HomeDrawer";
import { useAppSelector } from "../../../../app/hooks";
import { HOME_LAYOUT_HEIGHT } from "../../../../app/common";

export const ErrorLayout = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  const envName = process.env.REACT_APP_HOST_ENVIRONMENT_NAME;
  const user = useAppSelector((state) => state.user.user);

  let errorMsg: string;

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (isRouteErrorResponse(error)) {
    errorMsg = error.data?.message || error.statusText;
  } else if (error instanceof Error) {
    errorMsg = error.message;
  } else if (typeof error === "string") {
    errorMsg = error;
  } else {
    console.error(error);
    errorMsg = "Unknown error";
  }

  return (
    <Box sx={{ display: "flex" }}>
      <HomeMenu user={user} />
      <HomeDrawer />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
        }}
      >
        <Box
          height={HOME_LAYOUT_HEIGHT}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {envName === "dev" || envName === "test" ? (
            <Typography>{errorMsg}</Typography>
          ) : (
            <>
              <SmileSad
                style={{
                  width: "80px",
                  height: "80px",
                  opacity: 0.11,
                }}
              />
              <Typography
                variant="header"
                fontWeight={700}
                fontSize={18}
                mt={4}
              >
                {t("errors:somethingWentWrong")}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
